export default __webpack_public_path__ + "static/media/blue-icon.987a806f.svg";